import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";

import { EmojiPickerModule } from "@shared-components/emoji-picker";
import { ChatMentionsModule } from "@shared-components/chat-mentions";

import { TeamChatWidgetComponent } from "./team-chat-widget.component";

@NgModule({
	imports: [CommonModule, FormsModule, EmojiPickerModule, ChatMentionsModule],
	declarations: [TeamChatWidgetComponent],
	exports: [TeamChatWidgetComponent]
})
export class TeamChatWidgetModule { }
